import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const AthletaSVG = (
  <svg fill="none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M20 40C8.95431 40 0 31.0457 0 20S8.95431 0 20 0c11.0457 0 20 8.9543 20 20s-8.9543 20-20 20zm3.7462-8.6721c-.4862.5478-1.3414.5486-1.8286.0018L12.3161 20.554c-.3374-.3786-.3379-.9498-.0013-1.3291l1.0453-1.1777.0098.0109 8.5657-9.59469c.4776-.53497 1.315-.53334 1.7905.00348.4029.45477.4015 1.13906-.0031 1.59221l-8.7487 9.7997 8.7703 9.8429c.4128.4632.4135 1.1622.0016 1.6262z"
      fill="#000"
      fillOpacity=".75"
      fillRule="evenodd"
    />
  </svg>
);

const BananaRepublicSVG = (
  <svg fill="none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M0 20C0 8.9543 8.9543 0 20 0s20 8.9543 20 20-8.9543 20-20 20S0 31.0457 0 20zm23.9337 7.5585l-1.5124 1.5124-8.2352-8.2158-.0149.0149-.4334-.4621-1.0437-1.0412.0336-.0358-.0293-.0312.955-.9558.514-.548.0168.0168 8.1768-8.18372 1.5712 1.48362-8.2253 8.2222 8.2268 8.2237z"
      fill="#000"
      fillOpacity=".75"
      fillRule="evenodd"
    />
  </svg>
);

const GapSVG = (
  <svg fill="none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M0 20C0 8.9543 8.9543 0 20 0s20 8.9543 20 20-8.9543 20-20 20S0 31.0457 0 20zm23.9337 7.5585l-1.5124 1.5124-8.2352-8.2158-.0149.0149-.4334-.4621-1.0437-1.0412.0336-.0358-.0293-.0312.955-.9558.514-.548.0168.0168 8.1768-8.18372 1.5712 1.48362-8.2253 8.2222 8.2268 8.2237z"
      fill="#000"
      fillOpacity=".75"
      fillRule="evenodd"
    />
  </svg>
);

const OldNavySVG = (
  <svg fill="none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M20 0C8.9543 0 0 8.9543 0 20s8.9543 20 20 20 20-8.9543 20-20S31.0457 0 20 0zm1.8536 24.8448l-1.4118 1.4118-5.1736-5.1737-.0029.0029-1.4117-1.4118.0028-.0028-.0028-.0028 1.4117-1.4118.0029.0028 5.1736-5.1736 1.4118 1.4117-5.1737 5.1737 5.1737 5.1736z"
      fill="#000"
      fillOpacity=".75"
      fillRule="evenodd"
    />
  </svg>
);

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M0 20C0 8.9543 8.9543 0 20 0s20 8.9543 20 20-8.9543 20-20 20S0 31.0457 0 20zm23.9337 7.5585l-1.5124 1.5124-8.2352-8.2158-.0149.0149-.4334-.4621-1.0437-1.0412.0336-.0358-.0293-.0312.955-.9558.514-.548.0168.0168 8.1768-8.18372 1.5712 1.48362-8.2253 8.2222 8.2268 8.2237z"
      fill="#000"
      fillOpacity=".75"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: AthletaSVG,
  [Brands.BananaRepublic]: BananaRepublicSVG,
  [Brands.BananaRepublicFactoryStore]: BananaRepublicSVG,
  [Brands.Gap]: GapSVG,
  [Brands.GapFactoryStore]: GapSVG,
  [Brands.OldNavy]: OldNavySVG,
  crossBrand: CrossBrandSVG,
};

export const ChevronCircleIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
